<template> 
<clinic />
</template>

<script>
import Clinic from "@/components/Clinic";
import ClinicLayout from "@/layouts/ClinicLayout";

export default {
  components: {
    Clinic
  },
  created() {
    this.$emit("update:layout", ClinicLayout);
  }
};
</script>
